import {
  AddMission,
  ChevronLeftNav,
  ChevronRightNav,
  Plus,
} from 'assets/icons';
import Logo from 'assets/images/Jobbiz.svg';
import Button from 'components/button';
import useSlideOver from 'components/SlideOver/useSlideOver';
import Tooltips from 'components/tooltips/Tooltips';
import UseContext from 'hooks/useContext';
import Usefetchdata from 'hooks/usefetchdata';
import { useEffect, useRef, useState } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import CompanyDL from './Links/Desktop/CompanyDL';
import DashboardDL from './Links/Desktop/DashboardDL';
import IdentityValidationDL from './Links/Desktop/IdentityValidationDL';
import JobbizGameDL from './Links/Desktop/JobbizGameDL';
import IntercomDL from './Links/Desktop/IntercomDL';
import MissionPeriodDL from './Links/Desktop/missionPeriodDL';
import QualificationDL from './Links/Desktop/QualificationDL';
import TimeSheetDL from './Links/Desktop/timeSheetDL';
import VivierTaleez from './Links/Desktop/vivierTaleez.js';
import PayslipManagementDL from './Links/Desktop/PayslipManagementDL';

const SidebarDesktop = () => {
  const { sidebarExpanded, setSidebarExpanded, sidebarOpen, setSidebarOpen } =
    UseContext();
  const { toggleSlideOver } = useSlideOver();
  const trigger = useRef(null);
  const sidebar = useRef(null);
  const { userData } = Usefetchdata();
  const [role, setRole] = useState(500);
  const route = useLocation();
  const { pathname } = route;

  useEffect(() => {
    if (userData?.role) {
      setRole(userData.role);
    }
  }, [userData]);

  // Fermer la sidebar quand on change de page (sur mobile)
  useEffect(() => {
    if (sidebarOpen) {
      setSidebarOpen(false);
    }
  }, [pathname]);

  useEffect(() => {
    localStorage.setItem('sidebar-expanded', sidebarExpanded);
    if (sidebarExpanded) {
      document.querySelector('body').classList.add('sidebar-expanded');
    } else {
      document.querySelector('body').classList.remove('sidebar-expanded');
    }
  }, [sidebarExpanded]);

  useEffect(() => {
    const clickHandler = ({ target }) => {
      if (!sidebar.current || !trigger.current) return;
      if (
        !sidebarOpen ||
        sidebar.current.contains(target) ||
        trigger.current.contains(target)
      )
        return;
      setSidebarOpen(false);
    };
    document.addEventListener('click', clickHandler);
    return () => document.removeEventListener('click', clickHandler);
  });

  const handleCreateMission = () => {
    setSidebarOpen(false); // Fermer la sidebar sur mobile
    toggleSlideOver('add_mission');
  };

  return (
    <>
      <div
        id="sidebar"
        ref={sidebar}
        className={`flex flex-col absolute left-0 top-0 z-40 tab:static tab:left-auto tab:translate-x-0 tab:z-auto transform h-screen overflow-y-scroll tab:overflow-y-auto no-scrollbar w-60 tab:w-[80px] tab:sidebar-expanded:!w-64 shrink-0 bg-[#FCFCFC] p-4 transition-all duration-200 ease-in-out border-r border-gray-100 ${
          sidebarOpen ? 'translate-x-0' : '-translate-x-60'
        } `}
      >
        {/* Sidebar Header */}
        <div className="flex justify-between mb-10 pr-3 mm:px-2">
          {/* close Button */}
          <button
            className="tab:hidden text-gray-600 hover:text-slate-400"
            onClick={() => setSidebarOpen(!sidebarOpen)}
            aria-controls="sidebar"
            aria-expanded={sidebarOpen}
          >
            <span className="sr-only ">Fermer le menu</span>
            <ChevronLeftNav />
          </button>
          <NavLink
            end
            to="/dashboard"
            className={`flex items-center justify-center w-24 !sidebar-expanded:hidden`}
          >
            <img src={Logo} alt="logo" className="w-full" />
          </NavLink>
          {/* Expand / collapse button */}
          <div className="pt-3 hidden tab:inline-flex justify-end mt-auto">
            <div className="px-3 py-2">
              <Tooltips
                text={sidebarExpanded ? 'Reduire' : 'Agrandir'}
                placement="right"
              >
                <button onClick={() => setSidebarExpanded(!sidebarExpanded)}>
                  <span className="sr-only">Expand / collapse sidebar</span>
                  <ChevronRightNav
                    prop={'sidebar-expanded:rotate-180'}
                  ></ChevronRightNav>
                </button>
              </Tooltips>
            </div>
          </div>
        </div>
        <div className="space-y-8">
          <div>
            <ul className="flex flex-col gap-1">
              {(role === 500 || role === 515) && (
                <div className="flex flex-col pb-4">
                  <Button
                    size={'LG'}
                    color={'PRIMARY'}
                    onClick={handleCreateMission}
                  >
                    <div className={`flex items-center whitespace-nowrap ${sidebarExpanded ? 'justify-start gap-2' : 'justify-center gap-0 max-tab:gap-2'}`}>
                      <Plus wh={20} color={'#fff'} className="shrink-0" />
                      <span
                        className={
                          sidebarExpanded
                            ? 'inline'
                            : 'max-tab:inline tab:max-ls:hidden ls:hidden ls:sidebar-expanded:inline'
                        }
                      >
                        Créer une mission
                      </span>
                    </div>
                  </Button>
                </div>
              )}
              {/* Links */}
              <DashboardDL />
              {(role === 500 || role === 515) && (
                <>
                  <IdentityValidationDL pathname={pathname} tooltip={'right'} />
                  <TimeSheetDL pathname={pathname} tooltip={'right'} />
                  <CompanyDL pathname={pathname} tooltip={'right'} />
                  <MissionPeriodDL pathname={pathname} tooltip={'right'} />
                  <QualificationDL pathname={pathname} tooltip={'right'} />
                  <VivierTaleez />
                  {(userData?.accessPayslip || userData?.accessInvoice) && (
                    <PayslipManagementDL />
                  )}
                </>
              )}
              {role === 525 && (
                <>
                  <MissionPeriodDL />
                </>
              )}
              {/* Divider */}
              <hr className="w-full border-gray-100 my-2" />
              {/* Bottom Links */}
              <JobbizGameDL />
              <IntercomDL />
              {/*<ProfilDL pathname={pathname} tooltip={'right'}/>
                            <SearchMissionDL pathname={pathname} tooltip={'right'}/>
                            <DocumentsDL pathname={pathname} tooltip={'right'}/>
                            <MissionDL pathname={pathname} tooltip={'right'}/>
                            <hr className="w-[95%] h-px bg-gray-20 my-2"/>
                            <HelpDL pathname={pathname} tooltip={'right'}/>*/}
            </ul>
          </div>
        </div>
      </div>
    </>
  );
};

export default SidebarDesktop;
